
import React, { useState, useEffect } from 'react';
import axios from '../services/axios';

function CandidateHistory({ candidateId }) {
  const [candidates, setCandidates] = useState([]);

  useEffect(() => {
    axios
      .get(`/candidates/InActiveCandidate/${candidateId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('user.token')}`,
        },
      })
      .then((res) => {
        const data = res.data.candidates;
        const flattenArray = data.map((ele) => {
          let flatObject = { ...ele };
          const flatten = (obj) => {
            Object.keys(obj).forEach((key) => {
              if (typeof obj[key] === 'object') {
                Object.assign(flatObject, obj[key]);
                delete flatObject[key];
              }
            });
          };
          flatten(ele);
          return flatObject;
        });
        setCandidates(flattenArray);
      });
  }, [candidateId]);

  const uniqueKeys = Object.keys(
    candidates.reduce((acc, obj) => {
      Object.keys(obj).forEach((key) => {
        acc[key] = true;
      });
      return acc;
    }, {})
  );

  return (
    <div>
      {candidates.length > 0 ? <div style={{ overflowX: 'scroll' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: '#f2f2f2' }}>
            {uniqueKeys.map((key, index) => (
              <th
                className="table-column-head"
                style={{
                  border: '1px solid black',
                  padding: '10px',
                  width: '200px',
                  textAlign: 'center',
                }}
                key={index}
              >
                {key.toUpperCase()}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {candidates.map((obj, index) => (
            <tr key={index}>
              {uniqueKeys.map((key, index) => (
                <td
                  style={{
                    border: '1px solid black',
                    padding: '10px',
                    textAlign: 'center',
                  }}
                  key={index}
                >
                  {obj[key] || '-'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      </div> : <div><h1>Data not found</h1></div>}
    </div>
  );
}

export default CandidateHistory;
